import { apiFetch } from "./apiFetch";

let cache = new Map();
let inFlight = new Map();
const CACHE_DURATION = 3000; // 3s

// CONSULTAR MODELOS
export const getModelos = async (tipo = null) => {
  try {
    const key = `modelos|${tipo || ""}`;
    const now = Date.now();

    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    let url = "/agendamentos/modelos";

    if (tipo) {
      url += `?tipo=${tipo.toUpperCase()}`;
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        cache.set(key, {
          data,
          time: Date.now(),
        });

        return data;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar modelos:", error);
    return null;
  }
};

// CONSULTAR AGENDAMENTOS
export const getAgendamentos = async (
  limit = 20,
  before = null,
  beforeStamp = null
) => {
  try {
    const key = `${limit}|${before || "null"}|${beforeStamp || "null"}`;
    const now = Date.now();

    // Retorna cache se ainda está válido
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }

    // Se já há requisição em voo, reutiliza
    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    let url = `/agendamentos?limit=${limit}`;

    if (before) {
      url += `&before=${encodeURIComponent(before)}`;
    }

    if (beforeStamp) {
      url += `&beforeStamp=${encodeURIComponent(beforeStamp)}`;
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          throw new Error(`Erro na API: ${response.status}`);
        }

        const data = await response.json();

        cache.set(key, {
          data,
          time: Date.now(),
        });

        return data;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    console.error("Erro ao buscar agendamentos:", error);
    return null;
  }
};


// CRIAR AGENDAMENTO
export const postAgendamento = async (payload) => {
  try {
    const response = await apiFetch("/agendamentos", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Erro na API: ${response.status}`);
    }

    return await response.json();

  } catch (error) {
    console.error("Erro ao criar agendamento:", error);
    return null;
  }
};


export const removeAgendamento = async (agendamentoStamp) => {
  try {
    const response = await apiFetch("/agendamentos", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ agendamentoStamp }),
    });

    if (!response.ok) {
      throw new Error(`Erro na API: ${response.status}`);
    }

    return await response.json();

  } catch (error) {
    console.error("Erro ao remover agendamento:", error);
    return null;
  }
};


export const editarAgendamento = async (agendamentoStamp, newData) => {
  try {
    const response = await apiFetch("/agendamentos", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        agendamentoStamp,
        newData,
      }),
    });

    if (!response.ok) {
      throw new Error(`Erro na API: ${response.status}`);
    }

    return await response.json();

  } catch (error) {
    console.error("Erro ao editar agendamento:", error);
    return null;
  }
};